// Engineer Review Queue — design mock for the engineer-side Orchestrator view.
// Thin wrapper around the role-aware OrchestratorReviewQueueMock component
// (currently lives in the buyer folder as BuyerWorklistMockPage). Same component,
// role='engineer' flips KPI labels, action gating, and tooltips.
import React from 'react';
import BuyerWorklistMockPage from '../buyer/BuyerWorklistMockPage';

const EngineerReviewQueueMockPage: React.FC = () => {
  return <BuyerWorklistMockPage role="engineer" />;
};

export default EngineerReviewQueueMockPage;
